import { create } from 'apisauce'

import store from '../store'
import handleNetworkError from '../actions/network'
import { refreshUserToken } from '../actions/user'
import { getAPIEndpoint } from '../utils/apiConstants'
import { logout } from '../actions/application'

const baseURL = `${getAPIEndpoint()}/webtransporter`
const apiPrdNew = create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
})

const checkForToken = () => `bearer ${store.getState().user && store.getState().user.access_token}`

apiPrdNew.axiosInstance.interceptors.request.use(
  (config) => {
    const newConfig = {
      ...config,
      headers: {
        ...config.headers,
        Authorization: checkForToken(),
        'Content-Type': 'application/json',
      },
    }
    return newConfig
  },
  (error) => Promise.reject(error),
)

apiPrdNew.axiosInstance.interceptors.response.use(
  (response) => response,
  (error) =>
    new Promise((resolve, reject) => {
      if (error.response) {
        const statusCode = error.response.status
        if (statusCode === 401) {
          store.dispatch(logout())
        } else if (statusCode === 403) {
          store.dispatch(refreshUserToken())
        }
        store.dispatch(handleNetworkError(error.response.status, error.response.data))
        reject(error.response) // Reject with the error response
      } else {
        store.dispatch(handleNetworkError(0))
        reject(error) // Reject with the generic error
      }
    }),
)

apiPrdNew.axiosInstance.interceptors.request.use(
  (config) => config,
  (error) => {
    console.log(error)
    return Promise.reject(error)
  },
)

export default apiPrdNew
